import { render, staticRenderFns } from "./TipoInformePage.vue?vue&type=template&id=1c92a17c"
import script from "./TipoInformePage.js?vue&type=script&lang=js&external"
export * from "./TipoInformePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports